import { createUseStyles } from 'react-jss';
import { BUBBLE_BUTTON_SIZE } from './config';
export const useLivechatBubbleButtonStyles = createUseStyles({
    'livechat-button': ({ position, visible, theme }) => ({
        left: position === null || position === void 0 ? void 0 : position.x,
        top: position === null || position === void 0 ? void 0 : position.y,
        position: 'fixed',
        display: visible ? 'flex' : 'none',
        alignItems: 'center',
        cursor: 'move',
        background: theme.gradients['primary-hovered'],
        backgroundSize: 'contain',
        borderColor: 'transparent',
        borderRadius: '100%',
        borderWidth: 0,
        boxShadow: theme.shadows.dropdown,
        height: `${BUBBLE_BUTTON_SIZE}px`,
        justifyContent: 'center',
        width: `${BUBBLE_BUTTON_SIZE}px`,
        zIndex: 990000,
        '&:hover': {
            background: theme.gradients.primary,
        },
        '&:focus-visible': {
            boxShadow: `0 0 0 1px ${theme.colors.white}, 0 0 0 3px ${theme.colors.sea}`,
        },
    }),
});
